// import Vue from 'vue'
import {
	RUN_USER_LOGIN,RUN_GENERATE_2FA_QRCODE,RUN_VERIFY_2FA_QRCODE,RUN_DISABLE_2FA_QRCODE,RUN_USER_LOGIN_2FA,RUN_USER_RESET_PASSWORD_FROM_HASH,RUN_USER_FORGOT_PASSWORD, RUN_CHANGE_PASSWORD,
	RUN_USER_SIGNUP,RUN_VERIFY_LEAD_OTP,RUN_STATE_LOAD,RUN_REGISTER_STEP1,RUN_REGISTER_STEP4,RUN_REGISTER_STEP5,RUN_USER_LOGOUT,RUN_DELETE_DOC,SET_STATE,GET_TOKEN 
} from '../types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
import * as COMMON from './commomFunction'
import * as types from '@/types'
import { Const } from '../plugins/fxView/provider/candle-history/lib/const.cls'
export const actions = {	
//================================2FA============================================
	[RUN_GENERATE_2FA_QRCODE]({commit, state, getters}, credentials) {
		COMMON._executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials,'',commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.src_data = result.res_data
			}else{
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = true
				}
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[RUN_VERIFY_2FA_QRCODE]({commit, state, getters}, credentials) {
		COMMON._executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials,'',commit, (error, result)=>{
			if(!error){
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 1
				commit(SET_STATE, user_json)
				localStorage.setItem('unauthFlag', '')
				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 1						
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				credentials.localParams.parameter.div_show = ''
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = false
					
				}else{
					credentials.localParams.parameter.otp = ''
					credentials.localParams.parameter.div_show = ''
				}
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz1','success')
			}else{
				//credentials.localParams.parameter.div_show = ''
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = true
				}
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				
			}
		})
	},
	[RUN_DISABLE_2FA_QRCODE]({commit, state, getters}, credentials) {
		COMMON._executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials,'',commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.DisableOtp = ''
				credentials.localParams.parameter.div_show = ''
				credentials.localParams.parameter.generateQrCode()
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 0
				commit(SET_STATE, user_json)


				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 0						
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz2','success')
			}else{
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
//================================login==========================================
  	[RUN_USER_LOGIN]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_USER_LOGIN, credentials,'',commit, (error, result)=>{
			if(!error){

				localStorage.setItem('unauthFlag', '')

				if(parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 1){
					credentials.localParams.parameter.gAuthenticatorEnabled = true
				}else{
					result.res_data.user.loggedIn = true
					commit(SET_STATE, result.res_data.user)
					localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
					credentials.localParams.parameter.$router.replace('/dashboard')
				}
			}else{
				// COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		})
  	},
	[RUN_USER_LOGIN_2FA]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials,'',commit, (error, result)=>{
			if(!error){
				localStorage.setItem('unauthFlag', '')
				result.res_data.user.loggedIn = true
				commit(SET_STATE, result.res_data.user)
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))		
				credentials.localParams.parameter.$router.replace('/dashboard')		
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		})
  	},
//===========================Reset-password-from-hash============================
  	[RUN_USER_RESET_PASSWORD_FROM_HASH]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_RESET_PASSWORD_FROM_HASH, credentials,'',commit, (error, result)=>{
			if(!error){
				const _that = credentials.localParams.parameter
				_that.displayMessage = 1
				_that.displayMessageText = "Password has been changed successfully. Kindly click here tp login"
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter, 'errorMsz1','error')
			}
		})
  	},
//===========================forgot-password=====================================
  	[RUN_USER_FORGOT_PASSWORD]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_USER_FORGOT_PASSWORD, credentials,'',commit, (error, result)=>{
			if(!error){ 
				credentials.localParams.parameter.resend = true
				COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz3','success')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		})
  	},  	
  	[RUN_CHANGE_PASSWORD]({commit, state, getters}, credentials) {
  		COMMON._executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.clear()
				COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz4','success')
			}else{
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		}) 
	},
//================================signup=========================================
	[RUN_USER_SIGNUP]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_USER_SIGNUP, credentials,'',commit, (error, result)=>{
			if(!error){
				if(credentials.localParams.page){
					credentials.localParams.parameter.insertId = result.res_data.insertId
					COMMON._messageDisplayFunction(credentials.localParams.parameter,'OTP resend successfully','success')
				}else{
					credentials.localParams.parameter.insertId = result.res_data.insertId
				}
			}else{
				credentials.localParams.parameter.onCaptchaExpired()
				credentials.localParams.parameter.captchaVerified = false
				COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		})
  	},
	[RUN_VERIFY_LEAD_OTP]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_VERIFY_LEAD_OTP, credentials,'',commit, (error, result)=>{
			if(!error){
				COMMON._messageDisplayFunction(credentials.localParams.parameter,'SignUp successfully','success')
				result.res_data.user.loggedIn = true
				console.log('in otp');
				commit(SET_STATE, result.res_data.user)
				console.log('second otp');
				window.gtag('event', 'conversion', {'send_to': 'AW-757510680/xkhtCNDIsfEBEJjkmukC'});
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
				credentials.localParams.parameter.$router.replace('/dashboard')
				
			}else{
				if(result.res_msg == "OTP verification error"){
					let msg = "Incorrect OTP entered. Please check your email for the correct OTP"
					 COMMON._messageDisplayFunction(credentials.localParams.parameter,msg,'error')
				}else{
					COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
				}
				
			}
		})
  	},
  	[RUN_STATE_LOAD]({commit, state, dispatch,getters}, credentials){
  		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user) 
			user = JSON.parse(user)
		}
		if(user == null || user == '' || location.pathname == '/'){
			localStorage.setItem('unauthFlag', '')
		}
		if((user == null || user == '' || location.pathname !== '/forgot/password/' || location.pathname !== '/forgot-password') && location.pathname == '/Users/dashboard'){
			localStorage.setItem('unauthFlag', true)
		}
		else{
			commit(SET_STATE, user)
			if(user !== null && user !==''){
				localStorage.setItem('unauthFlag', '')
				 COMMON._executeApi("/get/fresh/user/data", credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
					if(!error){
						result.res_data.user.loggedIn = true
						commit(SET_STATE, result.res_data.user)
						localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))


						result.res_data.user.loggedIn = true
	                    commit(SET_STATE, result.res_data.user);

	                    localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
						if(credentials.localParams.page){
							credentials.localParams.parameter.pageLoader = false 	
						}
						
						if(credentials.localParams.page && credentials.localParams.page == 'individual_doc_step'){
							credentials.localParams.parameter.tierFunc()
						}else if(credentials.localParams.page && credentials.localParams.page != 'individual_doc_step'){
							credentials.localParams.parameter.$router.replace('/step3') 
						}else if(credentials.localParams.page && credentials.localParams.page === 'dashboard'){
							credentials.localParams.parameter.getReferalLinks(); 
						}
					}else{
						 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
					}
				}) 
			}
		}
  	},
//================================logout=========================================
	[RUN_USER_LOGOUT]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_ADMIN_LOGOUT, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				COMMON._handleLogout(result.data, commit, {router: credentials.localParams.parameter.$router, forward:true})
				localStorage.removeItem('lastPath');
			}else{
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
//================================register steps=================================	
	[RUN_REGISTER_STEP1]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_REGISTER_STEP1, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				//credentials.localParams.parameter.$parent.$parent.showStepComponent = true
				let user_json = getters['GET_USER']
				user_json.step = 1
				user_json.username = credentials.globalParams.fname +' '+ credentials.globalParams.mname +' '+ credentials.globalParams.lname
				user_json.profile.firstname = credentials.globalParams.fname 
				user_json.profile.middlename = credentials.globalParams.mname 
				user_json.profile.lastname = credentials.globalParams.lname
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.step = 1									
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				credentials.localParams.parameter.$router.replace('/step2')
			}else{
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		}) 
  	},
  	[RUN_REGISTER_STEP4]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_REGISTER_STEP4, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				let user_json = getters['GET_USER']
				user_json.step = 2
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.step = 2									
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				credentials.localParams.parameter.$router.replace('/step3')
			}else{
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[RUN_REGISTER_STEP5]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_REGISTER_STEP5, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
                if(credentials.localParams.step != undefined){
                	let user_json = getters['GET_USER']
					user_json.step = 3
					commit(SET_STATE, user_json)

					var user = localStorage.getItem('user')
					user = atob(user)	;	user = JSON.parse(user)
					user.step = 3									
					localStorage.setItem('user', btoa(JSON.stringify(user)))

					credentials.localParams.parameter.$parent.ticket_id = result.res_data[0].insertId
					localStorage.setItem('ticketId', result.res_data[0].insertId)
					// credentials.localParams.parameter.$router.replace('/dashboard')

					if(!(credentials.localParams.parameter.mobileScreen)){
						credentials.localParams.parameter.$router.replace({ name: "fxView.view", query: {'id':result.res_data[0].insertId}})
					}
                }else{
                	credentials.localParams.parameter.documentJsonData = {}
	                credentials.localParams.parameter.stepInfo()
	                credentials.localParams.parameter.clearOld()
	                credentials.localParams.parameter.showTab += 1
	                credentials.localParams.parameter.faliNameChange()
                }
				
			}else{
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	},
  	[RUN_DELETE_DOC]({commit, state, dispatch,getters}, credentials){
		COMMON._executeApi(Enpoints.EP_DELETE_DOC, credentials,{'Authorization': 'Bearer ' + getters[GET_TOKEN]},commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.documentJsonData = {}
                credentials.localParams.parameter.stepInfo()
			}else{
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
  	}
}





// WEBPACK FOOTER //
// ./src/store/actions.js